// extracted by mini-css-extract-plugin
module.exports = {"timer":"pieTimer-module--timer--3v-AL","time":"pieTimer-module--time--3AQI6","border":"pieTimer-module--border--1KQkR","mask":"pieTimer-module--mask--3vJ5w"};